import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class dmRoomReservation {
    RoomReservation:    RQService.Pms.GetRoomReservationsRow;

    HotelID:            number;
    LangID:             number;

    Arr:                Date;
    Dep:                Date;
    ArrDisplay:         string;
    DepDisplay:         string;

    IsCancelled:        boolean;
    HasCityTax:         boolean;
    RequestQuote:       boolean;
    HotelCurrencyLabel: string;
    TotalDisplay:       string;
    CityTaxDisplay:     string;

    RateName:           string;

    constructor(
         pHotelID:            number
        ,pLangID:             number
        ,pHotelCurrencyLabel: string
        ,pRoomReservation:    RQService.Pms.GetRoomReservationsRow
        ,pOfferTypeNameByID:  string[]
    ) {
        this.HotelID         = pHotelID;
        this.LangID          = pLangID;
        this.RoomReservation = pRoomReservation;

        this.Arr = new Date(
             parseInt(pRoomReservation.Arr.substr(0, 4))
            ,(parseInt(pRoomReservation.Arr.substr(5, 2)) - 1)
            ,parseInt(pRoomReservation.Arr.substr(8, 2))
        );

        this.Dep = new Date(
             parseInt(pRoomReservation.Dep.substr(0, 4))
            ,(parseInt(pRoomReservation.Dep.substr(5, 2)) - 1)
            ,parseInt(pRoomReservation.Dep.substr(8, 2))
        );

        this.ArrDisplay      = this.Arr.toLocaleDateString(
             RQApp.LangCodesByID[this.LangID]
            ,{
                 weekday: 'short'
                ,year:    'numeric'
                ,month:   'short'
                ,day:     'numeric'
            }
        );

        this.DepDisplay      = this.Dep.toLocaleDateString(
             RQApp.LangCodesByID[this.LangID]
            ,{
                 weekday: 'short'
                ,year:    'numeric'
                ,month:   'short'
                ,day:     'numeric'
            }
        );

        this.RateName = '';

        if (
            pOfferTypeNameByID[
                (pRoomReservation.OfferTypeID.toString())
            ]
        ) {
            this.RateName = pOfferTypeNameByID[
                (pRoomReservation.OfferTypeID.toString())
            ];
        }

        this.IsCancelled    = (this.RoomReservation.RoomReservationStatusID == 3);

        this.HasCityTax     = (this.RoomReservation.ServiceTotal > 0);

        this.TotalDisplay   = '€ ' + RQApp.FormatMoney(
             (this.RoomReservation.RoomTotal + this.RoomReservation.ServiceTotal)
            ,this.LangID
        );

        this.CityTaxDisplay = '€ ' +  RQApp.FormatMoney(
             this.RoomReservation.ServiceTotal
            ,this.LangID
        );

        this.RequestQuote   = (
            this.RoomReservation.RoomReservationStatusID == 1
        &&  this.RoomReservation.RoomTotal                < 1
        );
    }
}

export class dmBooking {
    Hotel:                 dmHotel;
    ReservationID:         number;
    LangID:                number;
    Display:               boolean;
    RoomResLoaded:         boolean;
    Booking:               RQService.Pms.GetReservationListRow;
    HotelInfo:             RQService.Ota.GetHotelInfoRow;
    
    IsCancelled:           boolean;
    HasCityTax:            boolean;
    HasNotes:              boolean;
    RequestQuote:          boolean;
    ExternalReservationID: string;
    HotelCity:             string;
    HotelName:             string;
    HotelCurrencyLabel:    string;
    FirstArrDisplay:       string;
    TotalDisplay:          string;
    CityTaxDisplay:        string;
    Notes:                 string;

    RoomReservations:      dmRoomReservation[];
    OfferTypeNameByID:     string[];
    Guest:                 RQService.Pms.GetGuestRow;

    constructor(
         pHotel:             dmHotel
        ,pBooking:           RQService.Pms.GetReservationListRow
        ,pHotelInfo:         RQService.Ota.GetHotelInfoRow
        ,pOfferTypeNameByID: string[]
        ,pHasHotelInfo:      boolean
        ,pLangID:            number
    ) {
        this.Hotel                 = pHotel;
        this.LangID                = pLangID;
        this.Display               = false;

        this.ReservationID         = pBooking.ReservationID;

        this.Booking               = pBooking;
        this.HotelInfo             = pHotelInfo;
        this.OfferTypeNameByID     = pOfferTypeNameByID;

        this.IsCancelled           = (pBooking.ReservationStatusID == 4);

        let arr: Date = new Date(
             parseInt(pBooking.FirstArr.substr(0, 4))
            ,(parseInt(pBooking.FirstArr.substr(5, 2)) - 1)
            ,parseInt(pBooking.FirstArr.substr(8, 2))
        );

        this.FirstArrDisplay       = arr.toLocaleDateString(
             RQApp.LangCodesByID[this.LangID]
            ,{
                 weekday: 'short'
                ,year:    'numeric'
                ,month:   'short'
                ,day:     'numeric'
            }
        );

        this.TotalDisplay          = '€ ' + RQApp.FormatMoney(
             this.Booking.ReservationTotal
            ,this.LangID
        );

        this.CityTaxDisplay        = '€ ' +  RQApp.FormatMoney(
             this.Booking.ServiceTotal
            ,this.LangID
        );

        this.HasCityTax            = (this.Booking.ServiceTotal > 0);

        this.Notes                 = this.Booking.Notes.trim();

        this.HasNotes              = (this.Notes != '');

        this.RequestQuote = (
            this.Booking.ReservationStatusID == 2
        &&  this.Booking.ReservationTotal    <  1
        );

        this.RoomResLoaded         = false;
        this.RoomReservations      = [];

        this.ExternalReservationID = this.Booking.ExternalReservationID;

        if (!this.ExternalReservationID) {
            this.ExternalReservationID = this.ReservationID.toString();
        }

        this.HotelCity             = 'City'
        this.HotelName             = 'Hotel';
        this.HotelCurrencyLabel    = '€';

        this.Guest                 = RQService.Pms.PopulateGetGuestRow({});

        let hotelInfoParams        = RQParam.OtaGetHotelInfoParams();

        hotelInfoParams.HotelID    = this.Hotel.HotelID;
        hotelInfoParams.LangID     = this.LangID;

        if (pHasHotelInfo) {
            if (this.HotelInfo.HotelCurrencySymbol != '') {
                this.HotelCurrencyLabel = this.HotelInfo.HotelCurrencySymbol;
            } else {
                this.HotelCurrencyLabel = this.HotelInfo.HotelCurrencyShortEn;
            }

            this.HotelCity = this.HotelInfo.City;
            this.HotelName = this.HotelInfo.HotelName;

            this.TotalDisplay   = this.HotelCurrencyLabel + ' ' + RQApp.FormatMoney(
                 this.Booking.ReservationTotal
                ,this.LangID
            );

            this.CityTaxDisplay = this.HotelCurrencyLabel + ' ' + RQApp.FormatMoney(
                 this.Booking.ServiceTotal
                ,this.LangID
            );
        }
    }

    public LoadRoomReservations(pAction: () => void): void {
        if (this.RoomResLoaded) { pAction(); return; }

        let roomResParams = RQParam.PmsGetRoomReservationsParams();

        roomResParams.HotelID       = this.Hotel.HotelID;
        roomResParams.ReservationID = this.ReservationID;
        roomResParams.LangID        = this.LangID;

        RQService.Pms.GetRoomReservations(roomResParams).then(result => {
            if (result.HasErrorOrException) { pAction(); return; }

            console.log('booking room res retrieved');

            let roomResList: any[] = result.RQueryResult;

            this.RoomReservations.length = 0;

            for (let i = 0; i < roomResList.length; i++) {
                let roomRes = RQService.Pms.PopulateGetRoomReservationsRow(
                    roomResList[i]
                );

                this.RoomReservations.push(
                    new dmRoomReservation(
                         this.Hotel.HotelID
                        ,this.LangID
                        ,this.HotelCurrencyLabel
                        ,roomRes
                        ,this.OfferTypeNameByID
                    )
                );
            }

            let guestParams = RQParam.PmsGetGuestParams();

            guestParams.HotelID = this.Hotel.HotelID;
            guestParams.GuestID = this.Booking.OwningGuestID;
            guestParams.LangID  = this.LangID;

            RQService.Pms.GetGuest(guestParams).then(result => {
                if (result.HasErrorOrException) { pAction(); return; }

                let guestResult: any[] = result.RQueryResult;

                let guest = RQService.Pms.PopulateGetGuestRow(
                    guestResult[0]
                );

                this.Guest = guest;

                this.RoomResLoaded = true;

                pAction();
            });
        });
    }
}

export class BookingsViewModel {
    BackToSignIn:      ()                 => void;
    NewLoading:        (pMessage: string) => dmLoading;

    mlText:            MLText;
    app:               mlBroker;
    ml:                mlBroker;
    Hotel:             dmHotel;
    LangID:            number;

    InRefresh:         boolean;

    HasHotelInfo:      boolean;
    HotelInfo:         RQService.Ota.GetHotelInfoRow;
    OfferTypeNameByID: string[];

    Bookings:          dmBooking[];

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                    => void
        ,pNewLoading:   (pMessage: string)    => dmLoading
    ) {
        this.mlText             = pMLText;
        this.LangID             = this.mlText.GetLangID();
        this.app                = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                 = this.mlText.GetBroker(
            'HotelAreaBookings'
        );

        this.Hotel              = pHotel;
        this.BackToSignIn       = pBackToSignIn;
        this.NewLoading         = pNewLoading;

        this.InRefresh          = false;

        this.Bookings           = [];
        this.OfferTypeNameByID  = [];

        this.HasHotelInfo       = false;
        this.HotelInfo          = RQService.Ota.PopulateGetHotelInfoRow({});

        let hotelInfoParams     = RQParam.OtaGetHotelInfoParams();

        hotelInfoParams.HotelID = this.Hotel.HotelID;
        hotelInfoParams.LangID  = this.LangID;

        RQService.Ota.GetHotelInfo(hotelInfoParams).then((result) => {
			let response = result as any;
	
			if (response.HasErrorOrException) { return; }
	
			let hotelInfoList = response.RQueryResult;
	
            if (hotelInfoList.length > 0) {
                let hotelInfoRow = RQService.Ota.PopulateGetHotelInfoRow(
                    hotelInfoList[0]
                );

                this.HasHotelInfo = true;
                this.HotelInfo    = hotelInfoRow;
            }

            let offerTypeParams     = RQParam.PmsGetOfferTypesParams();

            offerTypeParams.HotelID = this.Hotel.HotelID;
            offerTypeParams.LangID  = this.LangID;

            RQService.Pms.GetOfferTypes(offerTypeParams).then(result => {
                if (result.HasErrorOrException) { return; }

                let offerTypeList: any[] = result.RQueryResult;

                this.OfferTypeNameByID.length = 0;

                for (let i = 0; i < offerTypeList.length; i++) {
                    let offerType = RQService.Pms.PopulateGetOfferTypesRow(
                        offerTypeList[i]
                    );

                    this.OfferTypeNameByID[
                        (offerType.OfferTypeID.toString())
                    ] = offerType.OfferTypeName;
                }

                this.Refresh();
            });
        });
    }

    public Refresh(): void {
        if (this.InRefresh) { return; }

        this.InRefresh = true;

        let now        = new Date();

        let startDate  = new Date(
             now.getFullYear()
            ,now.getMonth()
            ,now.getDate()
        );

        let endDate    = new Date(
             now.getFullYear()
            ,now.getMonth()
            ,now.getDate()
        );

        startDate.setDate(startDate.getDate() - 100);

        let loading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            let resListParams = RQParam.PmsGetReservationListParams();

            resListParams.HotelID      = this.Hotel.HotelID;

            resListParams.SearchTypeID = 0;
            resListParams.StartDate    = RQApp.JSDateToRQString(startDate ,false);
            resListParams.EndDate      = RQApp.JSDateToRQString(endDate   ,false);
            resListParams.LangID       = this.LangID;

            RQService.Pms.GetReservationList(resListParams).then((result) => {
                if (result.HasErrorOrException) {
                    this.InRefresh = false;

                    loading.Dismiss();

                    return;
                }

                console.log('hotel bookings retrieved');

                let bookingList: any[] = result.RQueryResult;

                this.Bookings.length = 0;

                for (let i = 0; i < bookingList.length; i++) {
                    let booking = RQService.Pms.PopulateGetReservationListRow(
                        bookingList[i]
                    );

                    let bookingDetails = new dmBooking(
                         this.Hotel
                        ,booking
                        ,this.HotelInfo
                        ,this.OfferTypeNameByID
                        ,this.HasHotelInfo
                        ,this.LangID
                    );

                    this.Bookings.push(bookingDetails);
                }

                this.InRefresh = false;

                loading.Dismiss();
            });
        });
    }

    public OpenDetails(pBooking: dmBooking) {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        for (let i = 0; i < this.Bookings.length; i++) {
            this.Bookings[i].Display = false;
        }

        loading.Show(() => {
            pBooking.LoadRoomReservations(() => {
                pBooking.Display = true;

                loading.Dismiss();
            });
        });
    }

    public CloseDetails(pBooking: dmBooking) {
        pBooking.Display = false;
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/bookings/xv-bookings.ts